
































import { getEntityPage, navigateTo, replaceTab } from '@/common/RouteUtils';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { Vat, EntityStatus, Product, Site, ProductAccessory, SimproJobDetails } from '@/api';

import EntityPagination from '@/components/EntityPagination.vue';
import { VatDashboard } from './models/vat-dashboard';
import MilkVatDetail from './MilkVatDetail.vue';
import MilkVatsOverview from './MilkVatsOverview.vue';
import { getAlertText, showHelpTexts } from '@/common/HelpTextUtils';

@Component({
	components: {
		EntityPagination,
		MilkVatDetail,
		MilkVatsOverview,
	},
	methods: {
		getAlertText,
		showHelpTexts,
	},
})
export default class VatsTab extends Vue {
	@Prop({ required: true, type: Object })
	public readonly product!: Product & { site: Site | null };

	@Prop({ required: true, type: Array })
	public readonly vats!: Vat[];

	@Prop({ required: true, type: Array })
	public readonly vatDashboards!: VatDashboard[];

	@Prop({ required: false, type: Array })
	public readonly accessories: ProductAccessory[] | undefined;

	@Prop({ required: false, type: Array })
	public readonly accessoriesForInstall: ProductAccessory[] | undefined;

	@Prop({ required: false, type: Array })
	public readonly simproJobs?: SimproJobDetails[];

	public onPageChanged(newPageIndex: number): void {
		if (newPageIndex === this.currentPage || !this.$route.name?.startsWith('products.milk.vats.')) {
			return;
		}
		const vatId = this.vats[newPageIndex - 2]?.id?.toString();
		navigateTo(this.$router, {
			name: vatId ? 'products.milk.vats.detail.charts' : 'products.milk.vats.overview',
			params: {
				productId: this.$route.params.productId,
				...(vatId ? { vatId } : {}),
			},
		});
	}

	public get currentPage(): number {
		return getEntityPage(this.$route, this.vats, 'products.milk.vats', 'vatId');
	}

	@Watch('$route', { immediate: true })
	@Watch('vats')
	public ensureAvailableTab(): void {
		if (
			String(this.product.id) !== String(this.$route.params.productId) ||
			!this.$route.name?.startsWith('products.milk.vats.detail.') ||
			this.currentPage !== 1
		)
			return;
		replaceTab(this.$router, 'products.milk.vats.overview');
	}

	public get selectedVat(): Vat | null {
		// Current page is not zero-indexed
		if (this.currentPage === 1) {
			return null;
		}
		return this.vats[this.currentPage - 2] ?? null;
	}

	public get site(): Site | null {
		return this.product.site;
	}

	public get selectedVatDashboard(): VatDashboard | null {
		if (this.currentPage === 1) {
			return null;
		}
		return this.vatDashboards[this.currentPage - 2] ?? null;
	}

	public paginationText(vat: Vat): string {
		return vat.label ?? 'No Vat Label';
	}

	public badgeColor(vat: Vat): string {
		if (vat.status === EntityStatus.Live) {
			return 'success';
		} else if (vat.status === EntityStatus.Cancelled || vat.status === EntityStatus.Removed) {
			return 'danger';
		} else {
			return 'warning';
		}
	}

	public badgeText(vat: Vat): string {
		return Vue.filter('titleCase')(vat.status ?? 'No status');
	}

	public onOverviewVatClicked(index: number): void {
		// Zero based index.
		this.onPageChanged(index + 2);
	}
}
